<mydocma-app-pane-header [text]="('MM.pool.leftPane.title' | translate)"
                         [doneVisible]="false"
                         iconName="_defect_pool"
                         (closeClick)="onCloseClick()"
                         [closeVisible]="!(appContainerService.mobileView$ | async)">

</mydocma-app-pane-header>
<div style="position: relative; height: 100%;">

  <mydocma-loader *ngIf="!isPoolsLoaded" [size]="'small'" class="mydocma-mm-loader"></mydocma-loader>

  <mydocma-tree
    #tree [options]="poolTreeOptions" [nodeData]="poolScopes$ | async" class="left-pane-pool-tree"
    (nodeSelected)="onPoolClick($event?.data)">
    <!--    [selectedNodeId]="(poolStateService.currentLayoutState$ | async)?.pool?.Id?.toString()"-->

<!--    <div mydocmaTreeToolbarContent>-->
<!--    </div>-->

    <ng-template mydocmaTreeNodeContent let-tree let-node="node">
      <ng-container class="custom-node-container">
        <div class="node-container-wrapper" [class.pool-selected]="!node.data.scope && (isPoolSelected(node.data.Id) || isPoolExcluded(node.data.Id))">
          <ng-container [ngSwitch]="node.data.scope">
            <ng-container *ngSwitchCase="entityScopes.Project">
              <mydocma-custom-mat-icon class="pool-custom-icon" [iconName]="'_company'"></mydocma-custom-mat-icon>
            </ng-container>
            <ng-container *ngSwitchCase="entityScopes.User">
              <mydocma-custom-mat-icon class="pool-custom-icon" [iconName]="'_user'"></mydocma-custom-mat-icon>
            </ng-container>
          </ng-container>

<!--          <ng-container-->
<!--            *ngIf="!node.data.scope && (node.data.IsFavoriteAll || node.data.IsFavoriteUser) && (layoutFavoriteFilterMode$ | async) === layoutFavoriteFilterModes.showAll">-->
<!--            <mydocma-custom-mat-icon class="layout-group-custom-icon"-->
<!--                                     [iconName]="'_star-filled'"></mydocma-custom-mat-icon>-->
<!--          </ng-container>-->
<!--          <ng-container *ngIf="!node.data.scope && !node.data.IsFavoriteAll && !node.data.IsFavoriteUser && (layoutFavoriteFilterMode$ | async) === layoutFavoriteFilterModes.showAll">-->
<!--            <mydocma-custom-mat-icon class="layout-group-custom-icon" [iconName]="'_star'"></mydocma-custom-mat-icon>-->
<!--          </ng-container>-->
          <ng-container *ngIf="!node.data.scope">
            <div style="width: 8px; min-width: 8px; max-width: 8px"></div>
          </ng-container>
          <!--        test-->
          <span class="node-text" *ngIf="node.data.scope; else child">
            {{(node.text | translate)}} ({{node.filteredChildren?.length}})</span>
          <ng-template #child>
            <div #element class="node-text-container" [matTooltip]="getTooltipText(node)"
                 (mouseenter)="onMouseEnter(element)"
                 (click)="onPoolClick(node.data)">
              <span class="node-text-part" [class.pool-excluded]="isPoolExcluded(node.data.Id)">{{node.data.Name | translate}}</span>
              <span class="node-count-part">({{(platformModeStateService.isLocalMode$ | async) ? (node.data.LocalCount ?? 0) : (node.data.Count ?? 0)}})</span>
            </div>
          </ng-template>
          <ng-container [ngTemplateOutlet]="(node.data.scope ? menuPoolGroup : menuPool)"
                        [ngTemplateOutletContext]="{$implicit: node}"></ng-container>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #menuPoolGroup let-node="$implicit">
      <button
        #elem
        mat-icon-button
        *ngIf="(permissionDefectPoolsVisible$ | async) && ((scopeSortSetting[node.data.scope] !== 1) || (permissionDefectPoolsCreate$ | async))"
        (menuOpened)="toggleMenu(elem, 'open')"
        (menuClosed)="toggleMenu(elem, 'close')"
        [mydocmaMenuTriggerFor]="tagPoolGroupMenu" class="pool_moreHoriz"
        (click)="$event.stopPropagation()">
        <mydocma-custom-mat-icon
          [iconName]="'more_horiz'"></mydocma-custom-mat-icon>
      </button>

      <mat-menu #tagPoolGroupMenu="matMenu">
        <button mat-menu-item (click)="toTopPosition(node)" *ngIf="scopeSortSetting[node.data.scope] !== 1">
          <mydocma-custom-mat-icon [iconName]="'arrow_upward'"></mydocma-custom-mat-icon>
          <span>{{'MM.pool.leftPane.showFirst' | translate}}</span>
        </button>
        <button mat-menu-item (click)="addPool(node)" *ngIf="(permissionDefectPoolsCreate$ | async)">
          <mydocma-custom-mat-icon [iconName]="'_plus-math'"></mydocma-custom-mat-icon>
          <span>{{'MM.pool.leftPane.add' | translate}}</span>
        </button>
      </mat-menu>
    </ng-template>

    <ng-template #menuPool let-node="$implicit">
      <button
        #elem1
        *ngIf="(permissionDefectPoolsVisible$ | async) && (isDesktop || (!isDesktop && isPoolSelected(node.data.Id)))"
        (menuOpened)="toggleMenu(elem1, 'open')"
        (menuClosed)="toggleMenu(elem1, 'close')"
        mat-icon-button [mydocmaMenuTriggerFor]="tagPoolMenu" class="pool_moreHoriz"
        (click)="$event.stopPropagation()">
        <mydocma-custom-mat-icon
          [iconName]="'more_horiz'">
        </mydocma-custom-mat-icon>
      </button>

      <mat-menu #tagPoolMenu="matMenu">
         <button mat-menu-item (click)="filterInclude(node)">
          <mydocma-custom-mat-icon
            fontSet="material-icons-outlined"
            [iconName]="'_equal-sign'"></mydocma-custom-mat-icon>
          <span>{{'MM.pool.leftPane.filterInclude' | translate}}</span>
        </button>

     <button mat-menu-item (click)="filterExclusively(node)">
          <mydocma-custom-mat-icon
            fontSet="material-icons-outlined"
            [iconName]="'_not-equal'"></mydocma-custom-mat-icon>
          <span>{{'MM.pool.leftPane.filterExclusively' | translate}}</span>
        </button>
        <button mat-menu-item (click)="editPool(node)" *ngIf="(canUpdatePool(node.data) | async)">
          <mydocma-custom-mat-icon
            fontSet="material-icons-outlined"
            [iconName]="'edit'"></mydocma-custom-mat-icon>
          <span>{{'MM.pool.leftPane.edit' | translate}}</span>
        </button>
        <button mat-menu-item (click)="deletePool(node)" *ngIf="(canDeletePool(node.data) | async)">
          <mydocma-custom-mat-icon
            fontSet="material-icons-outlined"
            [iconName]="'delete'"></mydocma-custom-mat-icon>
          <span>{{'MM.pool.leftPane.delete' | translate}}</span>
        </button>
      </mat-menu>
    </ng-template>
  </mydocma-tree>
</div>

<div class="mobile-pane-footer" *ngIf="(appContainerService.mobileView$ | async)">
  <div style="margin-right: 10px">
    <button mat-stroked-button (click)="onCloseClick()" class="mydocma-btn-primary">
      {{'Ok'}}
    </button>
  </div>
</div>
